import React, { ReactNode } from 'react';
import Card from 'features/shared/components/card/Card';

interface Props {
  children: ReactNode;
}

const DataGridRow = (props: Props) => {
  return (
    <Card className="py-2 px-2 px-sm-3 mb-2">
      {props.children}
    </Card>
  );
}

export default DataGridRow;
